import React, { useState } from "react";
import Timer from "./Timer";

import axios from "axios";
import { useMediaQuery } from "react-responsive";
import OtpInput from "react-otp-input";
import { useNavigate } from "react-router-dom";

import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import MangeDashboard from "./Dashboard/ManageDashboard";
export default function SetPassword() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, seterror] = useState({ mobile: "", email: "" });
  const [choose, setChoose] = useState("mobile");
  const [flag, setflag] = useState(false);
  const [otp, setOtp] = useState("");
  const [passone, setPassOne] = useState("");
  const [passtwo, setPassTwo] = useState("");
  const navigate = useNavigate();

  const [errorp, setErrorp] = useState("");
  const [errorpp, setErrorpp] = useState("");

  var phone = "";
  var destination = "";
  try {
    const location = useLocation();
    destination = location.state.destination;
  } catch {}
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 768px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const handleChange = (otp) => setOtp(otp);

  function handlechoose() {
    setChoose("email");
  }

  function handlechooseMobile() {
    setChoose("mobile");
  }

  function handlecheck(event) {
    let tag = event.target.name;
    let pass = event.target.value;
    if (tag == "pass1") {
      var re = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");

      let valid = re.test(pass);

      if (valid) {
        setPassOne(pass);
        setErrorp("");
      } else if (pass == "") {
        setErrorp("");
      } else {
        setPassOne(pass);
        setErrorp("رمزعبور ضعیف !");
      }
    } else if (tag == "pass2") {
      let res = passone.localeCompare(pass);

      if (res == 0) {
        setErrorpp("");
      } else {
        setErrorpp(" عدم همخوانی رمز عبور !");
      }
    }
  }

  function handelSubmit(event) {
    if (errorpp) {
      toast.error("عدم همخوانی رمزعبور های وارد شده!");
      return;
    }

    if (!otp) {
      toast.error("لطفا کد تایید را وارد نمایید");
    }

    var formData = new FormData();
    formData.append("destination_address", destination);
    formData.append("verify_code", otp);
    formData.append("password", passone);

    axios({
      // Endpoint to send files
      url: "https://api.talaeshow.com/api/users/password-reset/",
      method: "POST",
      data: formData,
    })
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          toast.success("رمزعبور شما با موفقیت تغییر یافت ");

          setTimeout(() => {
            navigate("/sign");
          }, 2000);
        } else {
          toast.error(res.data["detail"]);
        }
      })
      .catch((error) => {
        console.log("error");

        if (error.response) {
        } else if (error.request) {
        } else if (error.message) {
        }
      });
  }

  return (
    <MangeDashboard>
      <div>
        <form className="text-center mt-2">
          <div className="authincation section-padding">
            <div className="container h-100">
              <div className="row justify-content-center h-100 align-items-center">
                <div className="col-xl-6 col-md-8">
                  <div className="auth-form">
                    <div className="card-body">
                      <form className={"mt-4"}>
                        <OtpInput
                          value={otp}
                          onChange={handleChange}
                          numInputs={6}
                          separator={<span> </span>}
                          containerStyle="div-ltr verify-code"
                          inputStyle="otp"
                        />
                        <div className="text-align-right mt-4">
                          <p className="text-end text-medium d-inline-flex pe-2">
                            کد تائید ارسال شده به {destination} را وارد کنید
                          </p>

                          <p className=" mymedium d-inline-flex ps-2 pe-2">
                            <span className="mymedium pe-2">
                              <Timer />
                            </span>
                          </p>
                        </div>
                        <div className="form-group text-end">
                          <div>
                            <span className="pe-2 mynormal">رمزعبور</span>

                            <div className="input-group mb-3 pt-1">
                              <input
                                type="password"
                                className="form-input-custom"
                                id={"pass"}
                                name={"pass1"}
                                required
                                onChange={handlecheck}
                              />
                            </div>
                          </div>
                          <div>
                            <span className="pe-2 mynormal">تکرار رمزعبور</span>

                            <div className="input-group mb-3 pt-1">
                              <input
                                type="password"
                                className="form-input-custom"
                                id={"pass2"}
                                name={"pass2"}
                                required
                                onChange={handlecheck}
                              />
                            </div>

                            {errorpp ? (
                              <span className="text-small text-danger padding-5612">
                                {errorpp}
                              </span>
                            ) : (
                              <span className="text-small text-muted padding-5612">
                                حداقل 8 کارکتر، با حرف بزرگ و لاتین شروع شود،
                                ترکیبی از حروف و اعداد باشد
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="text-center pt-3 w-100">
                          <button
                            disabled={flag}
                            type="button"
                            className="form-input-button-custom"
                            id="submit"
                            data-loading-text="<i className='fas fa-spinner fa-pulse'></i>"
                            onClick={handelSubmit}
                          >
                            {isLoading ? (
                              <div>
                                <i className="fa fa-spinner fa-spin"></i>
                              </div>
                            ) : (
                              <span>تایید</span>
                            )}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </MangeDashboard>
  );
}
